export default __webpack_public_path__ + "static/media/AluminumTableImg.f425c46a.jpg";